module.exports = __webpack_public_path__ + "img/e413bb4.svg";